// src/components/UI/MetricCard.jsx
import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const MetricCard = ({ value, label }) => {
  return (
    <Box
      p={4}
      bg="surface"
      borderRadius="md"
      border="1px solid"
      borderColor="gray.800"
      textAlign="center"
    >
      <Text fontSize="2xl" fontWeight="bold" color="secondary" mb={1}>{value}</Text>
      <Text fontSize="xs" color="gray.400">{label}</Text>
    </Box>
  );
};

export default MetricCard;